const loadImage = (src) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = reject;
    img.src = src;
  });
export const rotateFileWithCanvas = async (
  fileOrBlobUrl,
  originalFile,
  degrees,
) => {
  const img = await loadImage(fileOrBlobUrl);

  const angle = ((degrees % 360) + 360) % 360; // sécurité
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  // Pour 90° / 270°, largeur/hauteur inversées
  const swap = angle === 90 || angle === 270;
  canvas.width = swap ? img.height : img.width;
  canvas.height = swap ? img.width : img.height;

  ctx.translate(canvas.width / 2, canvas.height / 2);
  ctx.rotate((angle * Math.PI) / 180);
  ctx.drawImage(img, -img.width / 2, -img.height / 2);

  const blob = await new Promise((resolve) =>
    canvas.toBlob(resolve, originalFile.type || "image/jpeg", 0.92),
  );

  // Nouveau fichier “réellement” tourné
  const rotatedFile = new File([blob], originalFile.name, {
    type: originalFile.type || "image/jpeg",
    lastModified: Date.now(),
  });

  return rotatedFile;
};
